import { createFileRoute, notFound } from "@tanstack/react-router";
import ServicePage, { serviceSlugRedirects } from "@/pages/ServicePage";
import { legacyRedirect } from "@/lib/legacy-redirect";
import { isServiceSlug, serviceHead } from "@/lib/route-seo";
import NotFound from "@/pages/NotFound";

// Legacy slug redirects ported from src/App.tsx
const LEGACY_SLUGS: Record<string, string> = {
  "building-automation": "/hvac-services/building-automation-systems",
  "energy-consulting": "/energy-management/energy-efficiency-consulting",
  "performance-contracting": "/energy-management/guaranteed-energy-savings",
  "guaranteed-energy-savings-financing": "/energy-management/guaranteed-energy-savings",
  "led-lighting": "/energy-management/lighting-retrofits",
  "led-lighting-upgrades": "/energy-management/lighting-retrofits",
};

export const Route = createFileRoute("/energy-management/$slug")({
  beforeLoad: ({ params }) => {
    const target = LEGACY_SLUGS[params.slug];
    if (target) legacyRedirect(target);
    if (!isServiceSlug(params.slug) && !serviceSlugRedirects[params.slug]) throw notFound();
  },
  component: () => <ServicePage basePath="/energy-management" baseLabel="Energy Management" />,
  notFoundComponent: () => <NotFound hubPath="/energy-management" hubLabel="Energy Management" />,
  head: ({ params }) => serviceHead("/energy-management", "Energy Management", params.slug),
});
